import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../../components-core/data-grid/DataGridToolbar';
import { documentColumns } from '../../../../services/column-definitions';

const RootStyle = styled('div')({
  flexGrow: 1,
  display: 'flex',
  overflow: 'hidden',
  flexDirection: 'column'
});


export const DocumentList = props => {
  const { onOpenSidebar, hideSidebar, documents, queryCallback, loading } = props;

  const [columns, setColumns] = React.useState(documentColumns());

  const searchCallback = search => {
    queryCallback(search);
  };

  return (
    <RootStyle sx={{ opacity: loading ? 0.5 : 1 }}>
      <Box sx={{ minWidth: { md: 800 } }}>
        <DataGridPro
          columns={columns}
          rows={documents}
          density="compact"
          disableColumnMenu={true}
          autoPageSize={false}
          autoHeight={true}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          components={{
            Toolbar: DataGridToolbar
          }}
          componentsProps={{ toolbar: { onOpenSidebar, hideSidebar, miniView: false, searchCallback } }}
          localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          disableSelectionOnClick
        />
      </Box>
      {/* </Scrollbar> */}
    </RootStyle>
  );
};
